const BangkokFirstLoad = () => {
  // document?.getElementById("scroll_bangkok")?.scrollIntoView({
  //   behavior: "smooth",
  //   block: "start",
  // });
};
export default BangkokFirstLoad;
